// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleTicketManager = {
  id: "ticket-manager",
  mrn: "//iam.api.mondoo.app/roles/ticket-manager",
  title: "Ticket Manager",
  allowedActions,
} as const;

export type RoleTicketManager = typeof roleTicketManager;
